import type { ValueOf } from '~/types/value-of'

export const accountDetailPageType = {
  transactions: 'transactions',
  internalTransactions: 'internal-transactions',
  erc20: 'erc20',
  erc721: 'erc721',
  erc1155: 'erc1155',
  contractCode: 'contract-code',
  tokenTransfers: 'token-transfers',
  nftTransfers: 'nft-transfers',
  portfolio: 'portfolio',
} as const
export type accountDetailPageType = ValueOf<typeof accountDetailPageType>;

export const portfolioPageType = {
  tokens: 'tokens',
  nfts: 'nfts',
} as const
export type portfolioPageType = ValueOf<typeof portfolioPageType>;

export default {
  getAccountsPage() {
    return '/accounts'
  },
  getPortfolioPage(address: string, subTab?: portfolioPageType) {
    if (!subTab) subTab = portfolioPageType.tokens
    return `/accounts/${address}/portfolio/${subTab.toLowerCase()}`
  },
  getAccountDetailPageWithTab(address: string, tab?: accountDetailPageType, subTab?: portfolioPageType) {
    if (!tab) tab = accountDetailPageType.transactions
    if (tab === 'portfolio') {
      if (!subTab) subTab = portfolioPageType.tokens
      return this.getPortfolioPage(address, subTab)
    }
    return this.getAccountsPage() + `/${address}/${tab}`
  },
  getPortfolioPageWithTab(address: string, tab?: portfolioPageType) {
    if (!tab) tab = portfolioPageType.tokens
    return this.getPortfolioPage(address, tab)
  }
}